module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-top-og-image-5a91228d652a12aadd930dfeb68645e9.png";